/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import { truncateText } from "../../utils/helpers";

const JourneyCard = ({ data, onView, copyCode }) => {
  return (
    <div className="col">
      <div className="card card-profile" style={{ height: "100%" }}>
        <img
          src={data?.background_image}
          alt="Image placeholder"
          className="card-img-top cursor-pointer"
          onClick={() => onView(data)}
        />
        <div
          className="row justify-content-center cursor-pointer"
          onClick={() => onView(data)}
        >
          <div className="col-4 col-lg-4 order-lg-2">
            <div className="mt-n4 mt-lg-n6 mb-0 mb-lg-0 bg-white rounded-3">
              <img
                src={data?.image}
                className="card-logo-img rounded-3 img-fluid border border-5"
              />
            </div>
          </div>
        </div>

        <div className="card-body pt-0">
          <div className="text-center mt-4">
            <div className="d-flex align-items-center justify-content-center gap-2 mb-2">
              <strong className="text-dark"> Code :</strong>

              <div className="d-flex align-items-center justify-content-center gap-2">
                <span className="badge bg-light text-dark px-2 py-1">
                  {data?.uniqueJourneyId || "_ _"}
                </span>
                <button
                  type="button"
                  className="btn btn-sm "
                  style={{
                    border: "1px solid #006972",
                    color: "#006972",
                    backgroundColor: "transparent",
                    padding: "6px",
                    marginBottom: "1px",
                  }}
                  onClick={() => copyCode(data?.uniqueJourneyId || "_ _")}
                >
                  Copy Code
                </button>
              </div>
            </div>
            <h5>{data?.name}</h5>
            <div className="cardcontent">
              <p>{truncateText(data?.description)}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JourneyCard;
